import React from 'react';

const Problems = () => {
  const problems = [
    'Confused where to start',
    'Slow development cycles',
    'No clear product strategy',
    'Lack of reliable developers',
    'Running over budget constantly',
    'Idea stuck in planning stage'
  ];

  const solutions = [
    'MVP shipped in 3 weeks',
    'Crystal clear roadmap',
    'Dedicated expert team',
    'Predictable fixed pricing',
    'Rapid release cycles',
    'Real users & early traction'
  ];

  return (
    <section className="py-20 px-6 relative overflow-hidden bg-gradient-to-b from-black to-gray-900">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-extrabold mb-4 text-white">
            From <span className="text-gray-500 line-through">Stuck</span> to <span className="text-white">Shipped</span>
          </h2>
          <p className="text-gray-400 text-lg">We transform your challenges into opportunities</p>
        </div>

        <div className="grid md:grid-cols-2 gap-8">
          {/* Problems Column */}
          <div className="space-y-4">
            <h3 className="text-2xl font-bold text-gray-400 mb-6">Common Problems</h3>
            <div className="space-y-3">
              {problems.map((problem, index) => (
                <div
                  key={index}
                  className="bg-white/5 border border-white/10 rounded-lg p-4 text-gray-400 hover:border-white/20 transition-colors duration-300 backdrop-blur-sm"
                >
                  {problem}
                </div>
              ))}
            </div>
          </div>

          {/* Solutions Column */}
          <div className="space-y-4">
            <h3 className="text-2xl font-bold text-white mb-6">Our Solutions</h3>
            <div className="space-y-3">
              {solutions.map((solution, index) => (
                <div
                  key={index}
                  className="bg-white/10 border border-white/20 rounded-lg p-4 text-white hover:border-white/40 hover:bg-white/15 transition-all duration-300 backdrop-blur-sm"
                >
                  {solution}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Problems;